import { parsePreferencesField } from './parsePreferencesField';
import { DLOCAL_NOTIFICATION_TENANT_ID, normalizeNotificationPreferences } from './notificationPreferenceSettings';

const DEFAULT_NOTIFICATION_PREFS = {
  Complete: true,
  Update: true,
  'Status Change': true,
  'Critical Risk Alert': true,
};
const IN_APP_CATEGORIES = new Set(['Complete', 'Update', 'Status Change', 'Financial Report', 'Critical Risk Alert', 'Error']);

export async function loadInAppNotificationPreferences(service, userId, tenantId) {
  const strict = tenantId === DLOCAL_NOTIFICATION_TENANT_ID;
  const fallback = strict ? {} : { ...DEFAULT_NOTIFICATION_PREFS };
  if (!userId) return fallback;
  try {
    const response = await service.getUserPreferencesByUserIdAndFeature(userId, 'Notification Preferences', tenantId);
    const record = response?.data ?? response;
    if (strict && (!record || record.isDefault || record.isMissing)) return {};
    return strict
      ? normalizeNotificationPreferences(record.preferences)
      : parsePreferencesField(record?.preferences, DEFAULT_NOTIFICATION_PREFS);
  } catch (_) {
    return fallback;
  }
}

// Used by both the drawer list and its badge. Email and weekly preferences must
// never enable an in-app category, and unknown categories cannot inherit Notes.
export function isNotificationVisible(alert, preferences, userId, tenantId) {
  const type = alert.type;
  if (tenantId === DLOCAL_NOTIFICATION_TENANT_ID) {
    if (!IN_APP_CATEGORIES.has(type) || preferences[type] !== true) return false;
    if (type === 'Status Change' && Array.isArray(alert.approvers)) return alert.approvers.includes(userId);
    return true;
  }
  if (type === 'Update' && preferences.Update) return true;
  if (type === 'Status Change' && preferences[type]) {
    return !Array.isArray(alert.approvers) || alert.approvers.includes(userId);
  }
  if (type === 'Critical Risk Alert' && preferences[type]) return true;
  return (!type || !['Update', 'Status Change', 'Critical Risk Alert'].includes(type)) && Boolean(preferences.Complete);
}
